import register from '@wcd/preact-custom-element';
import { AuthorDescription } from '../../../types/web-components';
import { h } from "preact";
import { useState, useRef, useEffect } from 'preact/hooks';

export const component: AuthorDescription = ({description}) => {
  const [seeMoreToggle, setSeeMoreToggle] = useState(false);
  const [overflowActive, setOverflowActive] = useState(false);
  const textRef = useRef<HTMLParagraphElement | null>(null);

  const isOverflowActive = (event) => {
    return event.offsetHeight < event.scrollHeight || event.offsetWidth < event.scrollWidth;
  }

  useEffect(() => {
    if (isOverflowActive(textRef.current)) {
        setOverflowActive(true);
        return;
    }

    setOverflowActive(false);
  }, [isOverflowActive]);

  const handleClick = (e) => {
    e.preventDefault();
    setSeeMoreToggle(!seeMoreToggle);
  }

  return (
    <div>
      <p ref={textRef} className={seeMoreToggle ? "rdp-author__description-open" : "rdp-author__description"}>
        {description}
      </p>
      {!overflowActive && !seeMoreToggle ? null : (
      <a className='rdp-author__see-more' onClick={handleClick}>{seeMoreToggle ? 'See Less...' : 'See More...'}</a>
      )}
    </div>
  );
};
register(component, 'author-description', ['description'], { shadow: false });